import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type { RmaOptionsQuery, RmaOptionsQueryVariables } from '@/shared/api';
import RMA_OPTIONS_QUERY from '../queries/rmaOptions';

/**
 * Loads the active options of one RMA option category in the global option order. Runs the rmaOptions query on the RMA_INFO catalog and throws the first GraphQL error when no options came back.
 *
 * @param variables - Category of the options and, for reasons, the device model they apply to.
 * @returns A promise resolving to the options with their value, label, group and describe flag.
 */
const fetchRmaOptions = async (
  variables: RmaOptionsQueryVariables,
): Promise<RmaOptionsQuery['rmaOptions']> => {
  const client = createClient();
  const result = await client.query<RmaOptionsQuery, RmaOptionsQueryVariables>({
    query: RMA_OPTIONS_QUERY,
    variables,
  });
  return handleErrorApi(result, 'rmaOptions');
};

export default fetchRmaOptions;
